// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12C1 5.92487 5.92487 1 12 1ZM12 5.5C9.81217 5.5 8 7.24021 8 9.43359V10.4336H10V9.43359C10 8.38691 10.8741 7.5 12 7.5C13.1259 7.5 14 8.38691 14 9.43359V9.48145C13.9999 10.0691 13.7293 10.6324 13.252 11.0117L8.65527 14.6641C8.29644 14.9492 8.06424 15.3637 8.01172 15.8184L8 16.0156V18.5H16V16.5H10V16.1494L14.4961 12.5781C15.4435 11.8255 15.9999 10.6888 16 9.48145V9.43359C16 7.24021 14.1878 5.5 12 5.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-numbers-circle-2-filled')
export default class NumbersCircle2FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'numbers-circle-2-filled',
    }
  }
}
